import api from '@/lib/api/axios'

export interface IngressActiveItem {
    id: number
    objectId: string
    vaultId: string
    objectName: string
    datetime: string | null
    size: number | null
    sizeMB: number | null
    startDatetime: string | null
    vaultDatetime: string | null
    objectPrimary: string
    objectSecondary: string
    analytics: number | null
    percentageComplete: number
    applicationEncryption: number | null
    versionId: string | null
    currentState: string | null
    latestDetail: string | null
    lastStateChange: string | null
    lastUpdatedBy: string | null
    location: string | null
}

export interface IngressHistoryItem {
    objectStatus: string
    objectId: string
    vaultId: string
    objectName: string
    datetime: string | null
    minsDifference: number | null
    percentageComplete: number
    objectDescription: string
    vaultName: string
    location: string | null
}

export interface IngressSummaryItem {
    ingressDate: string | null
    noObjects: number
    noVersions: number
    noVaults: number
    noRegions: number
    noLocations: number
    noFinished: number
    sizeMB: number | null
}

export type IngressPeriod = 'day' | 'week' | 'month'

export const ingressMonitoringApi = {
    getActive: () =>
        api.get<IngressActiveItem[]>('/api/ingress-monitoring/active'),

    getHistory: (period: IngressPeriod = 'day') =>
        api.get<IngressHistoryItem[]>('/api/ingress-monitoring/history', { params: { period } }),

    getSummary: (period: IngressPeriod = 'week') =>
        api.get<IngressSummaryItem[]>('/api/ingress-monitoring/summary', { params: { period } }),
}
